import React from 'react';

import {MenuItem} from '@pb/kit-component-menu';
import {withCssModule} from '@pb/kit-util-with-css-module';

import styles from './autosuggest.component.module.styl';

import type {MenuItemProps} from '@pb/kit-component-menu';
import type {ReactNode} from 'react';


const classNames = withCssModule(styles);

type NativeProps = Omit<MenuItemProps, 'children'>;

interface AutosuggestListCaptionProps extends NativeProps {
    children: ReactNode,
}

/**
 * The `AutosuggestListCaption` component is used to render a caption/header in the Autosuggest Listbox.
 */
export const AutosuggestListCaption = ({children, ...props}: AutosuggestListCaptionProps) => (
    <MenuItem
        role="none"
        {...props}
        className={classNames('autosuggest-list__caption', props.className)}
        caption={children}
    />
);

AutosuggestListCaption.displayName = 'AutosuggestListCaption';
